// Home.js
import { useContext } from 'react'
import { Container, Row, Col, Button, Card, Nav } from 'react-bootstrap'
import logo from './poslogo.png'
import { ThemeContext } from '../components/ThemeContext.js'

const Home = () => {
  const { theme } = useContext(ThemeContext)

  return (
    <Container
      fluid='md'
      style={{ backgroundColor: theme.bg, color: theme.text }}
    >
      <Row>
        <Col>
          <Card
            className='my-2 py-2 rounded'
            style={{
              backgroundColor: theme.card,
              color: theme.text,
              borderColor: theme.sidebarAccent
            }}
          >
            <Card.Body>
              <Card.Title>Our Software</Card.Title>
              <Card.Text>
                GeraniumPoS is software as a service (SaaS) that allows you to
                maintain and track your inventory as a sole propietor or small
                business owner.
                <br />
                <br />
                Additionally there is an optional point of sale (POS) system
                that allows you to sell your products and services to your
                customers. You can send electronic receipts to the client in
                their GeraniumReceipt wallet.
                <br />
                <br />
                It is a simple and easy to use solution that will help you
                manage your inventory with an optional Point of Sale. We want to
                help you succeed.
              </Card.Text>
            </Card.Body>
            <Card.Footer
              style={{
                backgroundColor: theme.surfaceMuted,
                color: theme.subtext,
                borderColor: theme.sidebarAccent
              }}
            >
              For information:{' '}
              <a
                href='mailto:info@hermanosgazpachos.ca'
                style={{ color: theme.sidebarAccent }}
              >
                Click to send an email.
              </a>
              {' | '}
              <a
                href='https://geraniumreceipt.com'
                target='_blank'
                rel='noopener noreferrer'
                style={{ color: theme.sidebarAccent }}
              >
                Visit GeraniumReceipt.com
              </a>
            </Card.Footer>
          </Card>
        </Col>
        <Col>
          <div className='home-logo-wrap'>
            <img
              src={logo}
              alt='GeraniumPoS logo'
              className='home-logo-image'
              loading='lazy'
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Nav>
            <Nav.Link href='/owner'>
              <Button
                variant='outline-secondary'
                style={{
                  borderColor: theme.sidebarAccent,
                  color: theme.text
                }}
              >
                Register Your Business
              </Button>
            </Nav.Link>
          </Nav>
        </Col>
      </Row>
    </Container>
  )
}

export default Home
